import React from 'react';

const Privacy = () => {
  return (
    <div className="dashboard-page fade-in">
      <div className="dashboard-head">
        <h1 className="dashboard-page-title legal-page-title">Privacy Policy</h1>
        <p className="legal-page-meta">Last updated: January 2025</p>
      </div>

      <section className="card dashboard-section">
        <div className="dashboard-section-body">
          <div className="legal-content">
            <section className="legal-block">
              <h2 className="legal-heading">1. Information We Collect</h2>
              <p className="legal-text">
                We collect information you provide directly to us, such as when you create an account,
                complete KYC verification, or contact our support team. This may include your name,
                email address, phone number, and identification documents required for compliance.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">2. How We Use Your Information</h2>
              <p className="legal-text">
                We use the information we collect to operate, maintain, and provide the features of
                the platform, process transactions, verify your identity for compliance purposes,
                and communicate with you about your account.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">3. Data Security</h2>
              <p className="legal-text">
                We implement appropriate technical and organizational measures to protect your personal
                information against unauthorized access, alteration, disclosure, or destruction.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">4. Data Retention</h2>
              <p className="legal-text">
                We retain your personal information for as long as necessary to provide the services,
                comply with legal obligations, resolve disputes, and enforce our agreements.
              </p>
            </section>

            <section className="legal-block">
              <h2 className="legal-heading">5. Contact Us</h2>
              <p className="legal-text">
                If you have any questions about this Privacy Policy, please contact us at{' '}
                <a href="mailto:privacy@coinspire.com" className="legal-link">
                  privacy@coinspire.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;